var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlmatyArtSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1777 185.1",
    style: {
      enableBackground: "new 0 0 1777 185.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,11.8L9.3,174.8h22.1l3.3-30.7h18l3.3,30.7h23.9L58.6,11.8H29.2z M37.1,119.8l6.4-60.3l6.6,60.3H37.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.5,11.8 83.8,11.8 83.8,174.8 138.8,174.8 138.8,149.6 108.5,149.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "188.7,97.9 176.9,11.8 145.1,11.8 145.1,174.8 167.3,174.8 167.3,69.4 182.4,174.8 192.3,174.8  207.2,69.4 207.2,174.8 230.4,174.8 230.4,11.8 200.8,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.3,11.8l-19.9,163.1h22.1l3.3-30.7h18l3.3,30.7h23.9L283.6,11.8H254.3z M262.2,119.8l6.4-60.3l6.6,60.3 H262.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "391.9,72.5 380.5,11.8 361.7,11.8 356.4,11.8 295.5,11.8 295.5,35.5 316.3,35.5 316.3,174.8  340.9,174.8 340.9,35.5 361.7,35.5 361.7,34.2 378.8,106.9 378.8,174.8 403.5,174.8 403.5,107.1 425.2,11.8 402.9,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.5,11.8l-19.9,163.1h22.1l3.3-30.7h18l3.3,30.7h23.9L494.9,11.8H465.5z M473.4,119.8l6.4-60.3l6.6,60.3 H473.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M585,104.5c0-11-5.3-15.3-10.7-17.8c4.4-2,10.7-7.2,10.7-20.8V37c0-18.2-8.3-25.2-24.8-25.2h-40.1v163.1h24.8 v-72.8h6.4c7.9,0,9.2,3.1,9.2,10.3v49.1c0,8.8,1.3,11.6,2.4,13.4h24.5v-1.1c-1.1-2.4-2.4-5.5-2.4-12.1V104.5z M560.4,67.2 c0,7.2-2.2,11.6-9,11.6h-6.6V33.9h6.6c7.5,0,9,3.5,9,10.5V67.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "589.4,35.5 610.2,35.5 610.2,174.8 634.7,174.8 634.7,35.5 655.6,35.5 655.6,11.8 589.4,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M698.7,11.8l-19.9,163.1h22.1l3.3-30.7h18l3.3,30.7h23.9L728.1,11.8H698.7z M706.6,119.8l6.4-60.3l6.6,60.3 H706.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "796.9,99.2 775.7,11.8 753.3,11.8 753.3,174.8 775.7,174.8 775.7,81 799.3,174.8 819.5,174.8  819.5,11.8 796.9,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M866.6,11.8h-37.9v163.1h37.9c20.4,0,27.8-12.5,27.8-32.4V43.1C894.4,23.8,887.9,11.8,866.6,11.8z M869,138.5 c0,8.8-2.2,12.7-9.6,12.7h-5.9V33.9h7c6.1,0,8.5,3.3,8.5,12.7V138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M963.5,11.8h-37.9v163.1h37.9c20.4,0,27.8-12.5,27.8-32.4V43.1C991.3,23.8,984.7,11.8,963.5,11.8z  M965.9,138.5c0,8.8-2.2,12.7-9.6,12.7h-5.9V33.9h7c6.1,0,8.5,3.3,8.5,12.7V138.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1024.9,103 1049.6,103 1049.6,78.2 1024.9,78.2 1024.9,35.5 1056.4,35.5 1056.4,11.8 1000.1,11.8  1000.1,174.8 1057.7,174.8 1057.7,150.1 1024.9,150.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1098.7,71.6c-8.3-10.7-10.1-15.8-10.1-25v-3.1c0-7.7,1.3-11.4,7.2-11.4s7,4.2,7,9.6v23.5h23.9V38.5 c0-19.3-7.9-28.3-28.3-28.3h-4.6c-19.5,0-30.5,10.1-30.5,31.8v5.3c0,16.2,3.1,26.7,13.6,40.3l15.8,20.2c9,11.6,10.1,15.8,10.1,27.4 v3.7c0,10.1-2.2,14-8.1,14c-5.7,0-8.1-3.9-8.1-11.4V113h-24.5v32.7c0,20.2,10.5,30.9,30.2,30.9h4.8c21.7,0,32-14.2,32-38.1v-5.3 c0-18.4-3.5-26.7-14.7-41.2L1098.7,71.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1136.2,
    y: 11.8,
    className: "st0",
    width: 24.8,
    height: 163.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1200.8,100.8h11.2v40.8c0,6.1-2.8,10.5-9.2,10.5c-5,0-8.1-3.9-8.1-11.6V45.1c0-7.2,2.4-11.2,7.7-11.2 c6.1,0,7.9,3.9,7.9,11.2v18.4h24.1V46.9c0-19.3-3.1-36.6-29.6-36.6h-4.8c-23.5,0-30.5,16.9-30.5,35.1v101.9 c0,16.9,9.2,29.8,23.7,29.8h1.5c12.5,0,20.8-12.7,22.6-18.2c2,7,3.9,15.1,4.2,16h14V75.8h-34.6V100.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1287.6,99.2 1266.4,11.8 1244,11.8 1244,174.8 1266.4,174.8 1266.4,81 1290,174.8 1310.2,174.8  1310.2,11.8 1287.6,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1376.4,71.6c-8.3-10.7-10.1-15.8-10.1-25v-3.1c0-7.7,1.3-11.4,7.2-11.4s7,4.2,7,9.6v23.5h23.9V38.5 c0-19.3-7.9-28.3-28.3-28.3h-4.6c-19.5,0-30.5,10.1-30.5,31.8v5.3c0,16.2,3.1,26.7,13.6,40.3l15.8,20.2c9,11.6,10.1,15.8,10.1,27.4 v3.7c0,10.1-2.2,14-8.1,14c-5.7,0-8.1-3.9-8.1-11.4V113h-24.5v32.7c0,20.2,10.5,30.9,30.2,30.9h4.8c21.7,0,32-14.2,32-38.1v-5.3 c0-18.4-3.5-26.7-14.7-41.2L1376.4,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1448.5,10.3h-5.7c-22.4,0-29.6,16-29.6,32.7v99.5c0,16.4,5.5,34.4,30.5,34.4h5.5c23.9,0,29.6-17.8,29.6-35.3 v-37.7h-24.3v37.9c0,6.6-2.2,11-8.1,11c-5.5,0-7.9-3.9-7.9-11.2V44.7c0-7.2,1.5-10.7,7.7-10.7s8.3,3.7,8.3,10.7v28.7h24.3V44.2 C1478.7,28.2,1475.7,10.3,1448.5,10.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1528.3,77.1 1511.4,77.1 1511.4,11.8 1486.6,11.8 1486.6,174.8 1511.4,174.8 1511.4,103.2  1528.3,103.2 1528.3,174.8 1553,174.8 1553,11.8 1528.3,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1597.5,10.3h-4.2c-23.2,0-31.8,14.9-31.8,37.5v90.7c0,22.8,8.3,38.4,32,38.4h4.2c23.9,0,31.6-15.6,31.6-38.4 v-91C1629.3,25.2,1621.6,10.3,1597.5,10.3z M1604.1,140.2c0,7-1.8,12.5-8.3,12.5c-7,0-9-5.5-9-12.5V46.4c0-8.3,2.4-12.5,8.8-12.5 c5.7,0,8.5,3.9,8.5,12.5V140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.1,10.3h-4.2c-23.2,0-31.8,14.9-31.8,37.5v90.7c0,22.8,8.3,38.4,32,38.4h4.2c23.9,0,31.6-15.6,31.6-38.4 v-91C1704.9,25.2,1697.2,10.3,1673.1,10.3z M1679.7,140.2c0,7-1.8,12.5-8.3,12.5c-7,0-9-5.5-9-12.5V46.4c0-8.3,2.4-12.5,8.8-12.5 c5.7,0,8.5,3.9,8.5,12.5V140.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1738.2,149.6 1738.2,11.8 1713.5,11.8 1713.5,174.8 1768.5,174.8 1768.5,149.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmatyArtSchool);
export default __webpack_public_path__ + "static/media/ALMATY_ART_SCHOOL.31a616ff.svg";
export { ForwardRef as ReactComponent };var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlmatyArtSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1777 185.1",
    style: {
      enableBackground: "new 0 0 1777 185.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,11.8L9.3,174.8h22.1l3.3-30.7h18l3.3,30.7h23.9L58.6,11.8H29.2z M37.1,119.8l6.4-60.3l6.6,60.3H37.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.5,11.8 83.8,11.8 83.8,174.8 138.8,174.8 138.8,149.6 108.5,149.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "188.7,97.9 176.9,11.8 145.1,11.8 145.1,174.8 167.3,174.8 167.3,69.4 182.4,174.8 192.3,174.8  207.2,69.4 207.2,174.8 230.4,174.8 230.4,11.8 200.8,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.3,11.8l-19.9,163.1h22.1l3.3-30.7h18l3.3,30.7h23.9L283.6,11.8H254.3z M262.2,119.8l6.4-60.3l6.6,60.3 H262.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "391.9,72.5 380.5,11.8 361.7,11.8 356.4,11.8 295.5,11.8 295.5,35.5 316.3,35.5 316.3,174.8  340.9,174.8 340.9,35.5 361.7,35.5 361.7,34.2 378.8,106.9 378.8,174.8 403.5,174.8 403.5,107.1 425.2,11.8 402.9,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.5,11.8l-19.9,163.1h22.1l3.3-30.7h18l3.3,30.7h23.9L494.9,11.8H465.5z M473.4,119.8l6.4-60.3l6.6,60.3 H473.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M585,104.5c0-11-5.3-15.3-10.7-17.8c4.4-2,10.7-7.2,10.7-20.8V37c0-18.2-8.3-25.2-24.8-25.2h-40.1v163.1h24.8 v-72.8h6.4c7.9,0,9.2,3.1,9.2,10.3v49.1c0,8.8,1.3,11.6,2.4,13.4h24.5v-1.1c-1.1-2.4-2.4-5.5-2.4-12.1V104.5z M560.4,67.2 c0,7.2-2.2,11.6-9,11.6h-6.6V33.9h6.6c7.5,0,9,3.5,9,10.5V67.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "589.4,35.5 610.2,35.5 610.2,174.8 634.7,174.8 634.7,35.5 655.6,35.5 655.6,11.8 589.4,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M698.7,11.8l-19.9,163.1h22.1l3.3-30.7h18l3.3,30.7h23.9L728.1,11.8H698.7z M706.6,119.8l6.4-60.3l6.6,60.3 H706.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "796.9,99.2 775.7,11.8 753.3,11.8 753.3,174.8 775.7,174.8 775.7,81 799.3,174.8 819.5,174.8  819.5,11.8 796.9,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M866.6,11.8h-37.9v163.1h37.9c20.4,0,27.8-12.5,27.8-32.4V43.1C894.4,23.8,887.9,11.8,866.6,11.8z M869,138.5 c0,8.8-2.2,12.7-9.6,12.7h-5.9V33.9h7c6.1,0,8.5,3.3,8.5,12.7V138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M963.5,11.8h-37.9v163.1h37.9c20.4,0,27.8-12.5,27.8-32.4V43.1C991.3,23.8,984.7,11.8,963.5,11.8z  M965.9,138.5c0,8.8-2.2,12.7-9.6,12.7h-5.9V33.9h7c6.1,0,8.5,3.3,8.5,12.7V138.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1024.9,103 1049.6,103 1049.6,78.2 1024.9,78.2 1024.9,35.5 1056.4,35.5 1056.4,11.8 1000.1,11.8  1000.1,174.8 1057.7,174.8 1057.7,150.1 1024.9,150.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1098.7,71.6c-8.3-10.7-10.1-15.8-10.1-25v-3.1c0-7.7,1.3-11.4,7.2-11.4s7,4.2,7,9.6v23.5h23.9V38.5 c0-19.3-7.9-28.3-28.3-28.3h-4.6c-19.5,0-30.5,10.1-30.5,31.8v5.3c0,16.2,3.1,26.7,13.6,40.3l15.8,20.2c9,11.6,10.1,15.8,10.1,27.4 v3.7c0,10.1-2.2,14-8.1,14c-5.7,0-8.1-3.9-8.1-11.4V113h-24.5v32.7c0,20.2,10.5,30.9,30.2,30.9h4.8c21.7,0,32-14.2,32-38.1v-5.3 c0-18.4-3.5-26.7-14.7-41.2L1098.7,71.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1136.2,
    y: 11.8,
    className: "st0",
    width: 24.8,
    height: 163.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1200.8,100.8h11.2v40.8c0,6.1-2.8,10.5-9.2,10.5c-5,0-8.1-3.9-8.1-11.6V45.1c0-7.2,2.4-11.2,7.7-11.2 c6.1,0,7.9,3.9,7.9,11.2v18.4h24.1V46.9c0-19.3-3.1-36.6-29.6-36.6h-4.8c-23.5,0-30.5,16.9-30.5,35.1v101.9 c0,16.9,9.2,29.8,23.7,29.8h1.5c12.5,0,20.8-12.7,22.6-18.2c2,7,3.9,15.1,4.2,16h14V75.8h-34.6V100.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1287.6,99.2 1266.4,11.8 1244,11.8 1244,174.8 1266.4,174.8 1266.4,81 1290,174.8 1310.2,174.8  1310.2,11.8 1287.6,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1376.4,71.6c-8.3-10.7-10.1-15.8-10.1-25v-3.1c0-7.7,1.3-11.4,7.2-11.4s7,4.2,7,9.6v23.5h23.9V38.5 c0-19.3-7.9-28.3-28.3-28.3h-4.6c-19.5,0-30.5,10.1-30.5,31.8v5.3c0,16.2,3.1,26.7,13.6,40.3l15.8,20.2c9,11.6,10.1,15.8,10.1,27.4 v3.7c0,10.1-2.2,14-8.1,14c-5.7,0-8.1-3.9-8.1-11.4V113h-24.5v32.7c0,20.2,10.5,30.9,30.2,30.9h4.8c21.7,0,32-14.2,32-38.1v-5.3 c0-18.4-3.5-26.7-14.7-41.2L1376.4,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1448.5,10.3h-5.7c-22.4,0-29.6,16-29.6,32.7v99.5c0,16.4,5.5,34.4,30.5,34.4h5.5c23.9,0,29.6-17.8,29.6-35.3 v-37.7h-24.3v37.9c0,6.6-2.2,11-8.1,11c-5.5,0-7.9-3.9-7.9-11.2V44.7c0-7.2,1.5-10.7,7.7-10.7s8.3,3.7,8.3,10.7v28.7h24.3V44.2 C1478.7,28.2,1475.7,10.3,1448.5,10.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1528.3,77.1 1511.4,77.1 1511.4,11.8 1486.6,11.8 1486.6,174.8 1511.4,174.8 1511.4,103.2  1528.3,103.2 1528.3,174.8 1553,174.8 1553,11.8 1528.3,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1597.5,10.3h-4.2c-23.2,0-31.8,14.9-31.8,37.5v90.7c0,22.8,8.3,38.4,32,38.4h4.2c23.9,0,31.6-15.6,31.6-38.4 v-91C1629.3,25.2,1621.6,10.3,1597.5,10.3z M1604.1,140.2c0,7-1.8,12.5-8.3,12.5c-7,0-9-5.5-9-12.5V46.4c0-8.3,2.4-12.5,8.8-12.5 c5.7,0,8.5,3.9,8.5,12.5V140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.1,10.3h-4.2c-23.2,0-31.8,14.9-31.8,37.5v90.7c0,22.8,8.3,38.4,32,38.4h4.2c23.9,0,31.6-15.6,31.6-38.4 v-91C1704.9,25.2,1697.2,10.3,1673.1,10.3z M1679.7,140.2c0,7-1.8,12.5-8.3,12.5c-7,0-9-5.5-9-12.5V46.4c0-8.3,2.4-12.5,8.8-12.5 c5.7,0,8.5,3.9,8.5,12.5V140.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1738.2,149.6 1738.2,11.8 1713.5,11.8 1713.5,174.8 1768.5,174.8 1768.5,149.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmatyArtSchool);
export default __webpack_public_path__ + "static/media/ALMATY_ART_SCHOOL.31a616ff.svg";
export { ForwardRef as ReactComponent };